import { QUERY_RETURN_URL_ASPNET } from '../constants';

export default {
  methods: {
    getRedirectUrl: function (defaultUrl) {
      if (
        this.$store.state.returnUrl &&
        this.$store.state.returnUrl[QUERY_RETURN_URL_ASPNET]
      ) {
        return this.$store.state.returnUrl[QUERY_RETURN_URL_ASPNET];
      } else if (this.$store.state.defaultUrl) {
        return this.$store.state.defaultUrl;
      }

      return defaultUrl;
    }
  }
};
